import React, { Component } from 'react';
import { Card, CardActions, CardText, FlatButton, List, Drawer } from 'material-ui';
import PropTypes from 'prop-types';

import FilterButton from '../filterButton';
import FilteredLabel from './filteredLabel';
import ListFilter from './listFilter';
import ToggleFilter from './toggleFilter';
import IncludingPeriodFilter from './includingPeriod';
import TcDayPicker from '../../../tc-ui/date-picker';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';

const { bool, func, object, string } = PropTypes;

class DashboardFilterButton extends Component {
  onFilterChange = (e) => {
    const { updateGlobalFilter } = this.props;
    const [filterItem, value] = e.target.value.split('::');
    updateGlobalFilter(filterItem, value);
  };

  onListFilterChange = (obj) => {
    const { updateGlobalFilter } = this.props;
    console.log({obj})
    updateGlobalFilter(obj.filterKey, obj.value);
  };
  onContractingPeriodFieldChange = (value) => {
    this.props.updateGlobalFilter('contractingPeriod', value);
  };
  render() {
    const { filters, isFilterOpen, onButtonClick, onResetClick, onSubmitClick, filterLabel } = this.props;

    const filterArray = Object.values(filters)
        .filter(f => f.type !== 'date');

    const filterCount = filterArray.filter(f => f.selectedValue).length;
    return (
      <div>
        <FlatButton
          onTouchTap={onButtonClick}
          backgroundColor="rgba(0,0,0,0.04)"
          icon={<FilterIcon />}
          label={filterCount ? <FilteredLabel label="Filtered" count={filterCount}/> : filterLabel}
        />
        <Drawer
          open={isFilterOpen}
          onRequestClose={onButtonClick}
        >
          <List>
            { filterArray
            .sort((a, b) => b.title - a.title)
            .map((filter, i) => {
              if (filter.type === 'contractingPeriod') {
                return (<IncludingPeriodFilter
                  filterKey={filter.key}
                  key={i}
                  onFilterChange={this.onContractingPeriodFieldChange}
                  selectedValue={filter.selectedValue}
                  title={filter.title}
                  value={filter.value}
                />);
              }
              return (filter.type === 'list' ?
                  <ListFilter
                    filterKey={filter.key}
                    key={i}
                    onListFilterChange={this.props.updateGlobalListFilter}
                    clearListFilter={this.props.clearListFilter}
                    title={filter.title}
                    list={filter.list}
                  /> :
                  <ToggleFilter
                    filterKey={filter.key}
                    key={i}
                    onFilterChange={this.onFilterChange}
                    selectedValue={filter.selectedValue}
                    title={filter.title}
                    value={filter.value}
                  />
              );
            })
            }
          </List>
          <div
            className="flex-tc-sb"
            style={{ position: 'sticky', bottom: 0, width: '100%', padding: '8px', background: 'white' }}
          >
            <FlatButton label="Reset" onClick={onResetClick} />
            <FlatButton label="Apply" secondary onClick={onSubmitClick} />
          </div>
        </Drawer>
      </div>
      );
  }
}

DashboardFilterButton.propTypes = {
  filters: object,
  isFilterOpen: bool,
  onButtonClick: func,
  onResetClick: func,
  onSubmitClick: func,
  updateGlobalFilter: func,
  filterLabel: string,
  clearListFilter: func,
};

export default DashboardFilterButton;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/button.jsx